import styled, { css } from 'styled-components'

export const DatePlanContainer = styled.div`
  display: flex;
  gap: 1rem;
`
export const DateContainer = styled.div`
  width: 100%;
`
